<template>
  <div>
    <!-- HEADER -->

     <!-- Left side button - primary actions -->
      <div ref="primaryButton" class="d-none">
        <slot name="primaryButton"></slot>
      </div>

      <div ref="additionalToolButtons" class="d-none">
        <slot name="additionalToolButtons"></slot>
      </div>

      <div ref="dangerButton" class="d-none">
        <slot name="dangerButton"></slot>
      </div>

      <v-box ref="vbox" :delayedInit="true" data-test-path="vbox">
        <!-- CONTENT -->
          <slot>


          </slot>
        <!-- CONTENT END-->
      </v-box>

    <slot name="bottomLine"></slot>
      <!-- FOOTER -->
      <footer-navbar >
        <close-button @close="close"></close-button>
        <slot name="footer"></slot>
      </footer-navbar>
    <!-- FOOTER END -->

  </div>
</template>

<script>
import FormHeader from "@/components/forms/FormHeader";
import HeadersButtonGroup from "@/components/layout/HeaderButtonsGroup";
import FooterButton from "@/components/navbar/FooterButton";
import FooterNavbar from "@/components/navbar/FooterNavbar";
import CloseButton from "@/components/navbar/CloseButton";
import VBox from "@/components/VBox";
export default {
  name: "GridActivity",
  components: {VBox, CloseButton, FooterNavbar, FooterButton, HeadersButtonGroup, FormHeader},
  mounted() {
    let primaryButtons = this.$el.querySelector("[data-header-slot='primaryButtons']");
    let toolButtons = this.$el.querySelector("[data-header-slot='toolButtons']");
    let secondToolButtons = this.$el.querySelector("[data-header-slot='secondToolButtons']");
    let middleButtons = this.$el.querySelector("[data-header-slot='middleButtons']");
    let dangerButton = this.$el.querySelector("[data-header-slot='dangerButton']");

    primaryButtons?.appendChild(this.$refs.primaryButton);
    this.$refs.primaryButton.classList.remove("d-none");

    secondToolButtons?.appendChild(this.$refs.additionalToolButtons);
    this.$refs.additionalToolButtons.classList.remove("d-none");

    dangerButton?.appendChild(this.$refs.dangerButton);
    this.$refs.dangerButton.classList.remove("d-none");
    setTimeout(() => {
      this.$refs.vbox.delayedInitialize();
    });
  },
  methods: {
    close(){
      ActivityManager.findActivity(this.$el).close();
    }
  }
}
</script>

<style scoped>

</style>